import { Secure } from '@cv-invision/core';
import { PERMISSION, MAINPATHS } from '../model/global-configuration.constant';
import { LENDERS_CI_INSIDEMAPS_ROUTES, APPSCOPE_ROUTES } from '../model/routes/appscope-config-route.model';
import { NEXSYS_MAPPER } from '../model/routes/nexsys-mapper-route.model';
import {
	NEXSYS_MONITOR,
	NEXSYS_ORPHAN_MONITOR,
	VALUTRUST_MONITOR,
	XPANSE_MONITOR,
	FNC_MONITOR,
	ORDERS_MONITOR,
	BASE_MONITOR,
	ORDERS_EXTERNAL_MONITOR,
	EVO_MONITOR,
	NOT_ALLOWED,
	VALUELINK_MONITOR,
	CONNEXIONS_MONITOR,
	LENDING_QB_MONITOR,
	LANDGORILLA_MONITOR,
	FICS_MONITOR,
	MI_MUTUAL_MONITOR,
	RELIANCE_FIRST_MONITOR,
	VALUELINK_LENDER_MONITOR,
	LENDINGPAD_MONITOR,
} from '../model/routes/orders-monitor-route.model';
import {
	EMAIL_LIST_ROUTES,
	CLIENT_IDENTIFIER_LIST_ROUTES,
	OUTGOING_EVENTS_HYBRID_ROUTES,
	PRODUCT_IDENTIFIER_LIST_ROUTES,
} from '../model/routes/other-route.model';
import { PRODUCTS_ROUTES } from '../model/routes/products-main-route.module';
import { VALUTRUST_MAPPER } from '../model/routes/valutrust-mapper-route.model';
import { XPANSE_MAPPER } from '../model/routes/xpanse-mapper-route.model';
import { FNC_MAPPER } from '../model/routes/fnc-mapper-route.model';
import { GENERIC_MAPPER } from '../model/routes/generic-mapper-route.model';
import { DELIVERY_ASSETS_ROUTES } from "../model/routes/delivery-assets-route.model";
import { TENANT_ASSOCIATION_ROUTES } from '../model/routes/tenant-route.model';

/**
 * set the allow routes base on users permissions
 * @param routes
 * @returns Array<object>
 */
export function setRoutesByPermissions(routes:Array<object>): Array<object> {
	const setRoutes = new SetRoutesByPermisssions();
	return setRoutes.getRoutes(routes);
}

class SetRoutesByPermisssions {
	private defaultMainUrl:string;
	private childRoutes:Array<any>;
	private monitorRoutes:Array<object>;
	private monitorDefaultUrl:string;

	@Secure(PERMISSION.ORDERS_PRODUCTS)
	private productsRoutes(): void {
		this.defaultMainUrl = MAINPATHS.PRODUCTS;
		this.childRoutes = [...this.childRoutes, ...PRODUCTS_ROUTES];
	}

	@Secure(PERMISSION.ORDERS_MAPPERS)
	private integrationMappersRoutes(): void {
		this.defaultMainUrl  = this.defaultMainUrl || MAINPATHS.MAPPERS;
		this.childRoutes = [...this.childRoutes , ...NEXSYS_MAPPER, ...VALUTRUST_MAPPER, ...XPANSE_MAPPER, ...FNC_MAPPER, ...GENERIC_MAPPER];
	}

	@Secure(PERMISSION.ORDERS)
	private integrationAppScopeRoutes(): void {
		this.defaultMainUrl  = this.defaultMainUrl  || MAINPATHS.ORDERS,
		this.childRoutes = [...this.childRoutes , ...LENDERS_CI_INSIDEMAPS_ROUTES, ...APPSCOPE_ROUTES];
	}

	@Secure(PERMISSION.NEXSYS)
	private nexsysMonitorRoutes(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.NEXSYS;
		this.monitorRoutes = [...this.monitorRoutes , ...NEXSYS_MONITOR ];
	}

	@Secure(PERMISSION.NEXSYS_ORPHAN)
	private nexsysOrphanMonitorRoutes(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.ORPHANS;
		this.monitorRoutes = [...this.monitorRoutes , ...NEXSYS_ORPHAN_MONITOR ];
	}

	@Secure(PERMISSION.VALUTRUST)
	private valutrustMonitorRoutes(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.VALUTRUST;
		this.monitorRoutes = [...this.monitorRoutes , ...VALUTRUST_MONITOR ];
	}

	@Secure(PERMISSION.XPANSE)
	private xpanseMonitorRoutes(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.XPANSE;
		this.monitorRoutes = [...this.monitorRoutes , ...XPANSE_MONITOR ];
	}

	@Secure(PERMISSION.FNC)
	private fncMonitorRoutes(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.FNC;
		this.monitorRoutes = [...this.monitorRoutes , ...FNC_MONITOR ];
	}

	@Secure(PERMISSION.ORDERS_EXTERNAL)
	private accessOrderExternalMonitor(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.ORDERSEXTERNAL;
		this.monitorRoutes  = [...this.monitorRoutes  , ...ORDERS_EXTERNAL_MONITOR];
	}

	@Secure(PERMISSION.EVO)
	private accessEvoMonitor(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.ORDERSEXTERNAL;
		this.monitorRoutes  = [...this.monitorRoutes  , ...EVO_MONITOR];
	}

	@Secure(PERMISSION.ORDERS)
	private ordersListMonitorRoutes(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.ORDERS;
		this.monitorRoutes = [...this.monitorRoutes , ...ORDERS_MONITOR ];
	}

	@Secure(PERMISSION.CONFIG_ACCESS)
	private notAllowedConfigAccessRoutes(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.NOT_ALLOWED;
		this.monitorRoutes = [...this.monitorRoutes , ...NOT_ALLOWED ];
	}

	@Secure(PERMISSION.XPANSE_EVENTS)
	private notAllowedXpanseEventsRoutes(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.NOT_ALLOWED;
		this.monitorRoutes = [...this.monitorRoutes , ...NOT_ALLOWED ];
	}

	@Secure(PERMISSION.CONFIG_ACCESS)
	private deliveryAssetsRoutes(): void {
		this.defaultMainUrl  = this.defaultMainUrl || MAINPATHS.MAPPERS;
		this.childRoutes = [...this.childRoutes , ...DELIVERY_ASSETS_ROUTES];
	}

	@Secure(PERMISSION.MI_MUTUAL)
	private miMutual(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.MIMUTUAL;
		this.monitorRoutes = [...this.monitorRoutes , ...MI_MUTUAL_MONITOR ];
	}

	@Secure(PERMISSION.RELIANCE_FIRST)
	private relianceFirst(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.RELIANCEFIRST;
		this.monitorRoutes = [...this.monitorRoutes , ...RELIANCE_FIRST_MONITOR ];
	}

	@Secure(PERMISSION.ORDERS)
	private emailListRoutes(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.EMAILLIST;
		this.monitorRoutes = [...this.monitorRoutes , ...EMAIL_LIST_ROUTES ];
	}

	@Secure(PERMISSION.ORDERS)
	private outgoingEventsHybridRoutes(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.EMAILLIST;
		this.monitorRoutes = [...this.monitorRoutes , ...OUTGOING_EVENTS_HYBRID_ROUTES ];
	}

	@Secure(PERMISSION.CONFIG_ACCESS)
	private clientIdentifierListRoutes(): void {
		this.monitorRoutes = [...this.monitorRoutes , ...CLIENT_IDENTIFIER_LIST_ROUTES ];
	}

	@Secure(PERMISSION.CONFIG_ACCESS)
	private productIdentifierListRoutes(): void {
		this.monitorRoutes = [...this.monitorRoutes , ...PRODUCT_IDENTIFIER_LIST_ROUTES ];
	}

	@Secure(PERMISSION.VALUELINK)
	private valueLink(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.VALUELINK;
		this.monitorRoutes = [...this.monitorRoutes , ...VALUELINK_MONITOR ];
	}

	@Secure(PERMISSION.VALUELINK_LENDER)
	private valueLinkLender(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.VALUELINK_LENDER;
		this.monitorRoutes = [...this.monitorRoutes , ...VALUELINK_LENDER_MONITOR ];
	}

	@Secure(PERMISSION.CONNEXIONS)
	private connexions(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.CONNEXIONS;
		this.monitorRoutes = [...this.monitorRoutes , ...CONNEXIONS_MONITOR ];
	}

	@Secure(PERMISSION.LENDING_QB)
	private lendingQb(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.LENDINGQB;
		this.monitorRoutes = [...this.monitorRoutes , ...LENDING_QB_MONITOR ];
	}

	@Secure(PERMISSION.LANDGORILLA)
	private landGorilla(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.LENDINGQB;
		this.monitorRoutes = [...this.monitorRoutes , ...LANDGORILLA_MONITOR ];
	}

	@Secure(PERMISSION.FICS)
	private fics(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.FICS;
		this.monitorRoutes = [...this.monitorRoutes , ...FICS_MONITOR ];
	}

	@Secure(PERMISSION.LENDINGPAD)
	private lendingPad(): void {
		this.monitorDefaultUrl = this.monitorDefaultUrl || MAINPATHS.MONITORS.LENDINGPAD;
		this.monitorRoutes = [...this.monitorRoutes , ...LENDINGPAD_MONITOR ];
	}

	@Secure(PERMISSION.CONFIG_ACCESS)
	private tenantAssociationRoutes(): void {
		this.defaultMainUrl  = this.defaultMainUrl || MAINPATHS.MAPPERS;
		this.childRoutes = [...this.childRoutes , ...TENANT_ASSOCIATION_ROUTES];
	}

	/**
	 * monitor route build
	 */
	private ordersMonitorRoutes(): void {
		this.monitorDefaultUrl = null;
		this.nexsysMonitorRoutes();
		this.nexsysOrphanMonitorRoutes();
		this.valutrustMonitorRoutes();
		this.xpanseMonitorRoutes();
		this.fncMonitorRoutes();
		this.accessOrderExternalMonitor();
		this.accessEvoMonitor();
		this.ordersListMonitorRoutes();
		this.notAllowedConfigAccessRoutes();
		this.notAllowedXpanseEventsRoutes();
		this.deliveryAssetsRoutes();
		this.miMutual();
		this.relianceFirst();
		this.emailListRoutes();
		this.outgoingEventsHybridRoutes();
		this.clientIdentifierListRoutes();
		this.productIdentifierListRoutes();
		this.valueLink();
		this.valueLinkLender();
		this.connexions();
		this.lendingQb();
		this.landGorilla();
		this.fics();
		this.lendingPad();
		this.tenantAssociationRoutes();
		if (this.monitorRoutes.length) {
			BASE_MONITOR[0].redirectTo = this.monitorDefaultUrl
			this.childRoutes = [...this.childRoutes, ...BASE_MONITOR, ...this.monitorRoutes];
		}
	}

	/**
	 * build the entire  route tree for GC and the default main url
	 * @param routes object
	 * @returns
	 */
	public getRoutes(routes:Array<object>): Array<object> {
		this.childRoutes = routes;
		this.monitorRoutes = [];
		this.productsRoutes();
		this.integrationMappersRoutes();
		this.ordersMonitorRoutes();
		this.integrationAppScopeRoutes();
		this.childRoutes[0]['redirectTo'] = this.defaultMainUrl || this.monitorDefaultUrl;
		this.childRoutes =  [...this.childRoutes];
		return this.childRoutes;
	}
}
